import Slide from "react-reveal";
import { Trans } from "@lingui/macro";
import styled from "styled-components/macro";
import { ThemedText } from "theme";
import Data from "assets/images/Home/data.jpeg"
import Friends from "assets/images/Home/friends.jpeg"
import TV from "assets/images/Home/tv.jpeg"
import Wifi from "assets/images/Home/wifi.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { AutoColumn } from "components/Column";
import { ButtonLink } from "components/Button";
import { isMobile } from "utils/userAgent";

const PageWrapper = styled.div`
    max-width: 1200px;
    width: 100%;
    padding: 1rem;
    margin: auto;
    margin-top: 2rem;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        max-width: 800px;
    `};

    ${({ theme }) => theme.mediaWidth.upToSmall`
        max-width: 350px;
    `};
`;

const ResponsiveBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 5rem;
    gap: 2rem;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        flex-direction: column;
    `};

    ${({ theme }) => theme.mediaWidth.upToSmall`
        flex-direction: column;
    `};
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
`;

const Image = styled.img`
    width: 400px;
    border-radius: 16px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
        width: 100%;
    `};

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `};
`;


export function Info() {
    return (
        <PageWrapper>
            <Slide left>
                <ResponsiveBox>
                    <Image src={Data} alt="data-img" />
                    <AutoColumn style={{ gap: '2rem' }}>
                        <Row>
                            <FontAwesomeIcon icon={faCircleCheck} fontSize={30} color="#5B83B8" />
                            <ThemedText.Body color="text1">
                                <Trans>Competitive prices for telecommunications products</Trans>.
                            </ThemedText.Body>
                        </Row>
                        <Row>
                            <FontAwesomeIcon icon={faCircleCheck} fontSize={30} color="#5B83B8" />
                            <ThemedText.Body color="text1">
                                <Trans>Cutting-edge technology to provide the best connectivity</Trans>.
                            </ThemedText.Body>
                        </Row>
                        <Row>
                            <FontAwesomeIcon icon={faCircleCheck} fontSize={30} color="#5B83B8" />
                            <ThemedText.Body color="text1">
                                <Trans>Customer service available 24 hours a day</Trans>.
                            </ThemedText.Body>
                        </Row>
                    </AutoColumn>
                </ResponsiveBox>
            </Slide>
            <Slide right>
                <ResponsiveBox>
                    {isMobile && <Image src={Wifi} alt="wifi-img" />}
                    <AutoColumn style={{ gap: '1rem' }}>
                        <ThemedText.LargeHeader color="primary1">
                            <Trans>High-speed connectivity for everyone</Trans>
                        </ThemedText.LargeHeader>
                        <ThemedText.Body color="text1" textAlign="justify">
                            <Trans>At VidPay Telecom, we are dedicated to providing you with the best high-speed connectivity so that you can always stay connected. Our fiber and mobile services, fiber-only, and mobile-only options offer you the best choice to enjoy fast and reliable connection anywhere in the world. Whether you're at home, in the office, or traveling, our international network ensures a seamless browsing experience</Trans>.
                        </ThemedText.Body>
                        <ThemedText.Body color="text1" textAlign="justify">
                            <Trans>Contact us today and discover how we can improve your connectivity!</Trans>
                        </ThemedText.Body>
                        <ButtonLink to="/atencion-cliente" width="fit-content">
                            <Trans>Contact</Trans>
                        </ButtonLink>
                    </AutoColumn>
                    {!isMobile && <Image src={Wifi} alt="wifi-img" />}
                </ResponsiveBox>
            </Slide>
            <Slide left>
                <ResponsiveBox>
                    <Image src={TV} alt="TV-img" />
                    <AutoColumn style={{ gap: '1rem' }}>
                        <ThemedText.LargeHeader color="primary1">
                            <Trans>Quality TV, direct to your sofa: join the fun!</Trans>
                        </ThemedText.LargeHeader>
                        <ThemedText.Body color="text1" textAlign="justify">
                            <Trans>Explore a world of entertainment from the comfort of your home with Vidpay</Trans>.
                        </ThemedText.Body>
                        <ButtonLink to="/tv" width="fit-content">
                            <Trans>More Info</Trans>
                        </ButtonLink>
                    </AutoColumn>
                </ResponsiveBox>
            </Slide>
            <Slide right>
                <ResponsiveBox>
                    {isMobile && <Image src={Friends} alt="recommend-img" />}
                    <AutoColumn style={{ gap: '1rem' }}>
                        <ThemedText.LargeHeader color="primary1">
                            <Trans>Recommend fibre + mobile pack and get 1 month for free</Trans>
                        </ThemedText.LargeHeader>
                        <ThemedText.Body color="text1" textAlign="justify">
                            <Trans>If you are a customer, invite your friends to hire and enjoy a free month of fibre. To get one month free, you must have hired a fiber+mobile tariff, and your referrals must hire for a tariff equal to or higher than yours</Trans>.
                        </ThemedText.Body>
                        <ButtonLink to="/recomendados" width="fit-content">
                            <Trans>More Info</Trans>
                        </ButtonLink>
                    </AutoColumn>
                    {!isMobile && <Image src={Friends} alt="recommend-img" />}
                </ResponsiveBox>
            </Slide>
        </PageWrapper>
    );
}
